import { render } from "./OfflineOrderDetail.vue?vue&type=template&id=f4aa4252&scoped=true"
import script from "./OfflineOrderDetail.vue?vue&type=script&lang=js"
export * from "./OfflineOrderDetail.vue?vue&type=script&lang=js"

import "./OfflineOrderDetail.vue?vue&type=style&index=0&id=f4aa4252&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4aa4252"]])

export default __exports__